import React from 'react';
import { getCurrentPageQueryParams } from '@utils/tools';
import { appMethod as app } from '@utils/app';
import './Paying.less';

export default class Paying extends React.Component {
  constructor(props){
    super(props);
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    console.log(options);
    this.orderId = options.orderId;
    if(!this.orderId){
      console.error('orderId 参数未传');
      return;
    }
    if(options && options.isPayBack == 1){
      this.getOrder();
    }else{
      history.replaceState(null, null, location.href + '&isPayBack=1');
    }
  }

  getOrder(){
    app.sendRequest({
      url: '/index.php?r=AppShop/getOrder',
      data: {
        order_id: this.orderId,
        sub_shop_app_id: this.franchisee
      },
      success: (res) => {
        let payCallbackUrl = app.getStorageSync('payCallbackUrl');
        if(res.data[0].form_data.status != 0){
          payCallbackUrl.successUrl && app.turnToPage(payCallbackUrl.successUrl, {}, true);
        }else{
          payCallbackUrl.failUrl && app.turnToPage(payCallbackUrl.failUrl, {}, true);
        }
        app.removeStorage({key: 'payCallbackUrl'});
      },
      fail: () => {
        
      }
    });
  }

  render(){
    return (
      <div className="paying-tip">正在支付。。。</div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/official-page/paying/Paying.jsx